module.exports = __webpack_public_path__ + "img/pro-p-slider9.5a717759.png";